<template>
  <div
    v-if="show"
    class="search-modal-backdrop"
    @click="$emit('close')"
  >
    <div class="search-modal" @click.stop>
      <div class="search-modal-header">
        <h5>Деталі рішення</h5>
        <button @click="$emit('close')" class="close-btn">
          <i class="mdi mdi-close"></i>
        </button>
      </div>
      <div class="search-modal-body solution-details-modal">
        <!-- Додатково по проблемі -->
        <div class="details-card">
          <h6 class="details-card-title">
            <i class="mdi mdi-alert-circle-outline"></i>
            Додатково по проблемі
          </h6>

          <!-- Чому виникла проблема -->
          <div v-if="ticket.problemIn" class="details-field">
            <label>Чому виникла проблема?</label>
            <p>{{ ticket.problemIn }}</p>
          </div>

          <!-- Чи була проблема раніше -->
          <div
            v-if="
              ticket.problemWas !== null &&
              ticket.problemWas !== undefined
            "
            class="details-field"
          >
            <label>Чи була ця проблема раніше?</label>
            <span
              :class="[
                'badge',
                ticket.problemWas ? 'badge-danger' : 'badge-success',
              ]"
            >
              {{ ticket.problemWas ? "Так" : "Ні" }}
            </span>
          </div>

          <!-- Якщо проблема була раніше -->
          <template v-if="ticket.problemWas">
            <div v-if="ticket.sinceProblemKnown" class="details-field">
              <label>Скільки часу про проблему відомо?</label>
              <p>{{ ticket.sinceProblemKnown }}</p>
            </div>

            <div v-if="ticket.solutionReason" class="details-field">
              <label>Причина довгого вирішення проблеми</label>
              <p>{{ ticket.solutionReason }}</p>
            </div>
          </template>
        </div>

        <!-- Тестування -->
        <div
          v-if="
            ticket.decidedStatus &&
            [
              'waittesting',
              'pre_release',
              'waitrelease',
              'inrelease',
            ].includes(ticket.decidedStatus)
          "
          class="details-card"
        >
          <h6 class="details-card-title">
            <i class="mdi mdi-test-tube"></i>
            Тестування
          </h6>

          <!-- Чи тестувалось -->
          <div
            v-if="
              ticket.passedTest !== null &&
              ticket.passedTest !== undefined
            "
            class="details-field"
          >
            <label>Чи було протестовано рішення?</label>
            <span
              :class="[
                'badge',
                ticket.passedTest ? 'badge-success' : 'badge-danger',
              ]"
            >
              {{ ticket.passedTest ? "Так" : "Ні" }}
            </span>
          </div>

          <!-- Хто тестував -->
          <div
            v-if="
              ticket.passedTest &&
              ticket.whoPassedTest &&
              ticket.whoPassedTest.length > 0
            "
            class="details-field"
          >
            <label>Хто проводив тестування:</label>
            <ul class="testers-list">
              <li
                v-for="(tester, index) in ticket.whoPassedTest"
                :key="index"
              >
                {{ tester.workerName }}
              </li>
            </ul>
          </div>
        </div>

        <div
          v-if="!ticket.problemIn && ticket.passedTest === null"
          class="no-details"
        >
          <i class="mdi mdi-information-outline"></i>
          <p>Додаткова інформація відсутня</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SolutionDetailsModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    ticket: {
      type: Object,
      required: true,
    },
  },
  emits: ["close"],
};
</script>

<style scoped>
.search-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-modal {
  width: 600px;
  max-height: 80vh;
  background: white;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.search-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e9ecef;
}

.search-modal-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #6c757d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;
}

.close-btn:hover {
  background: #f8f9fa;
  color: #212529;
}

.search-modal-body {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.solution-details-modal {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 70vh;
  overflow-y: auto;
}

.details-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e9ecef;
}

.details-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e9ecef;
}

.details-card-title i {
  font-size: 18px;
  color: #007aff;
}

.details-field {
  margin-bottom: 16px;
}

.details-field:last-child {
  margin-bottom: 0;
}

.details-field label {
  display: block;
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 6px;
  font-weight: 600;
}

.details-field p {
  margin: 0;
  font-size: 13px;
  color: #212529;
  line-height: 1.6;
  padding: 10px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.details-field .badge {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.badge-success {
  background: #e8f5e9;
  color: #34c759;
}

.badge-danger {
  background: #ffebee;
  color: #dc3545;
}

.testers-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.testers-list li {
  padding: 8px 12px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  margin-bottom: 6px;
  font-size: 13px;
  color: #212529;
}

.testers-list li:last-child {
  margin-bottom: 0;
}

.no-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  color: #adb5bd;
  text-align: center;
}

.no-details i {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.no-details p {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}

@media (max-width: 768px) {
  .search-modal {
    width: 90%;
    max-width: 500px;
  }

  .search-modal-header {
    padding: 16px 20px;
  }

  .search-modal-header h5 {
    font-size: 16px;
  }

  .solution-details-modal {
    padding: 16px;
  }

  .details-card {
    padding: 12px;
  }

  .details-card-title {
    font-size: 13px;
    margin-bottom: 12px;
    padding-bottom: 10px;
  }

  .details-field {
    margin-bottom: 12px;
  }

  .details-field label {
    font-size: 11px;
  }

  .details-field p {
    font-size: 12px;
    padding: 8px;
  }

  .testers-list li {
    padding: 6px 10px;
    font-size: 12px;
  }
}

@media (max-width: 576px) {
  .search-modal {
    width: 95%;
    max-height: 90vh;
  }

  .search-modal-header {
    padding: 12px 16px;
  }

  .search-modal-header h5 {
    font-size: 15px;
  }

  .solution-details-modal {
    padding: 12px;
    max-height: 75vh;
  }

  .details-card {
    padding: 10px;
  }

  .details-card-title {
    font-size: 12px;
  }

  .no-details {
    padding: 20px 16px;
  }

  .no-details i {
    font-size: 28px;
  }

  .no-details p {
    font-size: 11px;
  }
}
</style>
